module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS.459255f.eot";